// NEW
window.landyReviewData = (mergeObj) => ({
  ...mergeObj,
  view: "start",
  reviews: [], // store of parsed reviews
  totalPages: null, // update this with the actual pagination count from judge.me
  reviewData: null,  // store of raw review widget data from call
  summary: "",
  inited: false,
  error: false,
  loading: true,
  noReviews: false,

  // Form
  formSubmitting: false,
  formSuccess: false,
  formSuccessMsg: "Thanks for your review",
  formErrors: [],
  formName: "",
  formNameDisplay: "", // options: last_initial, all_initials, anonymous
  formEmail: "",
  formRating: 5,
  formReviewTitle: "",
  formReview: "",
  checkReviewTitleLength: function(){
    if (this.formReviewTitle.length > 100) {
        this.formReviewTitle = this.formReviewTitle.substring(0,100)
    }
  },
  checkReviewLength: function(){
    if (this.formReview.length > 5000) {
        this.formReview = this.formReview.substring(0,5000)
    }
  },
  validateReview: function() {
    this.formErrors = [];
    if (!this.formName.length) { this.formErrors.push("Please enter your name") }
    if (!this.formEmail.length) { this.formErrors.push("Please enter your email") }
    if (!this.formReviewTitle.length) { this.formErrors.push("Please enter a review title") }
    if (!this.formReview.length || this.formReview.length < 10) { this.formErrors.push("Please enter a review") }
    return this.formErrors.length == 0;
  },
  submitReview: function(){
    let proceed = this.validateReview();
    if (proceed){
        this.formSubmitting = true;
        // Collect review info
        let formData = {
          url: window.location.host,
          shop_domain: Shopify.shop,
          platform: "shopify",
          name: this.formName,
          reviewer_name_format: this.formNameDisplay,
          email : this.formEmail,
          rating : this.formRating,
          title : this.formReviewTitle,
          body : this.formReview,
          id : meta.product.id // Product id
        };
        // console.log(formData);

        // Build formData object.
        let formDataObject = new FormData();
        formDataObject.append('url', formData.url);
        formDataObject.append('shop_domain', formData.shop_domain);
        formDataObject.append('platform', formData.platform);
        formDataObject.append('name', formData.name);
        formDataObject.append('reviewer_name_format', formData.reviewer_name_format);
        formDataObject.append('email', formData.email);
        formDataObject.append('rating', formData.rating);
        formDataObject.append('title', formData.title);
        formDataObject.append('body', formData.body);
        formDataObject.append('id', formData.id);

        fetch(`https://judge.me/api/v1/reviews`,{
          method: 'POST',
          body: formDataObject,
        })
        .then(response => response.json())
        .then(data => {
          // console.log(data);
          if (data.hasOwnProperty('message')) {
            this.formSuccessMsg = data.message;
          }
          this.formSubmitting = false;
          this.formSuccess = true;
        })
        .catch(e => {
          console.error(e);
          this.formSubmitting = false;
          this.formErrors = ["Sorry, something went wrong submitting your review"];
        });
    }
  },

  // Sorting
  sorting: "default",
  get_sort_by: function() {
    switch(this.sorting) {
      case "default":
        return "rating";
      case "most_recent":
        return "created_at";
      case "highest_rating":
        return "rating";
      case "lowest_rating":
        return "rating";
      case "only_pictures":
        return "with_pictures";
      case "pictures_first":
        return "pictures_first";
      case "videos_first":
        return "videos_first";
      case "most_helpful":
        return "most_helpful";
    }
  },
  get_sort_direction: function() {
    switch(this.sorting) {
      case "default":
        return "desc";
      case "most_recent":
        return "desc";
      case "highest_rating":
        return "desc";
      case "lowest_rating":
        return "asc";
      case "only_pictures":
        return "";
      case "pictures_first":
        return "";
      case "videos_first":
        return "";
      case "most_helpful":
        return "";
    }
  },

  init: function () {
    if (!this.inited) {
      this.fetchReviews();
    	this.judgeMeWidgetId = Math.random().toString(36).substring(4);
        const summaryData = document.querySelector('#landyReviewSummary');
        if (summaryData) {
          this.summary =   summaryData.innerHTML;
        }
      this.inited = true;
      this.debug = 'Initialised';
    }
  },

  parseData: function () {
    // turn it into a virual element we can parse
    const widgetWrapper = document.createElement('div');
    widgetWrapper.innerHTML = this.reviewData.html;

    // Get last page of pagination if not set
    if (this.totalPages === null) {
        let lastPageEl = widgetWrapper.querySelector('.jdgm-paginate__last-page');
        if (lastPageEl) {
            this.totalPages = parseInt(lastPageEl.dataset.page);
        }
    }

    // parse the reviews into finer points
    this.reviews = [...widgetWrapper.querySelectorAll('.jdgm-rev')]
      .map(function(rev) {
        let reviewData = {
          author: rev.querySelector('.jdgm-rev__author').textContent,
          title: rev.querySelector('.jdgm-rev__title').textContent,
          body: rev.querySelector('.jdgm-rev__body').innerHTML,
          score: parseFloat(rev.querySelector('.jdgm-rev__rating').getAttribute('data-score')),
        };

        // Reply
        let replyEl = rev.querySelector('.jdgm-rev__reply');
        if (replyEl && replyEl.innerHTML.trim()) {
          // console.log("found reply");
          reviewData['reply'] = replyEl.innerHTML;
        }

        // Video May or may not exist
        let vidEl = rev.querySelector('.jdgm-vid-player');
        if (vidEl) {
          // console.log(vidEl.dataset);
        }
        if (vidEl && vidEl.dataset.externalId){
          reviewData['vids'] = vidEl.dataset.externalId;
        }


        // Image may not exist
        // if they do then copy their data-src attr to src
        let reviewImagesEl = rev.querySelectorAll('.jdgm-rev__pics .jdgm-rev__pic-link');
        let reviewImages = document.createElement("div");
        if (reviewImagesEl) {
          reviewImagesEl.forEach((imgLink) => {
            let img = imgLink.querySelector('img');
            if (img) {
              img.setAttribute("src", img.dataset.src);
              reviewImages.appendChild(imgLink);
            }
          });
          reviewData['images'] = reviewImages.innerHTML;
        }
        return reviewData;
      }
      )
      .map((rev) => ({
        ...rev,
        // craft a star string, with halves, reusing existing assets
        stars: `<span class="jdgm-star jdgm--on"></span>`.repeat(rev.score)
          + (rev.score % 1 != 0 ? `<span class="jdgm-star jdgm--half"></span>` : '') // if has any decimals, append a half
      }));
  },

  // Get parsed reviews with optional limit and sort
  getReviews: function (limit = 10, sort = 'none') {
    if (!this.reviews.length) {
        return [];
    }
    let r = this.reviews;
    if (sort === "score") {
        r.sort((a, b) => b.score - a.score);
    }
    return r.slice(0,limit);
  },

  fetchReviews: function () {
    let reviewToken = 'KxYuC0q53KsYF84otWCHg7Z7-l0';
    let reviewPerPage = '10';
    const url = `https://cache.judge.me/widgets/shopify/lucy-yak.myshopify.com?public_token=${reviewToken}&review_widget_product_ids=${this.productId}&page=${this.page}&per_page=${reviewPerPage}&sort_by=${this.get_sort_by()}&sort_dir=${this.get_sort_direction()}`;
    fetch(url)
      .then(response => response.json())
      .then(data => {
        // console.log(data);
        this.reviewData = data;
        this.debug = 'Fetched'; 
        this.parseData();
        this.loading = false;
      })
      .catch(e => {
        console.error(e);
        this.loading = false;
        this.error = true;
      });
  },

	// Scroll to top
	scrollToTop: function() {
		const e = document.getElementById("alpineReviews");
		if (e) {
			e.scrollIntoView({ block: 'start',  behavior: 'smooth' });
		}
	},

  // Load next page
  loadNext: function() {
    this.page++;
    if (this.totalPages && this.page > this.totalPages){
      this.page = this.totalPages;
    }
		this.scrollToTop();
    this.loading = true;
    this.fetchReviews();
  },

  // Load previous page
  loadPrevious: function() {
    this.page--;
    if (this.page < 0){ // just in case
      this.page = 0;
    }
		this.scrollToTop();
    this.loading = true;
    this.fetchReviews();
  },

  // Has a next page of reviews
  hasNext: function() {
    if (this.page && this.totalPages) {
      if (this.page < this.totalPages) {
        return true;
      }
    }
    return false;
  },

  // Has a prev page of reviews
  hasPrevious: function() {
    if (this.page && this.totalPages) {
      if (this.page > 0) {
        return true;
      }
    }
    return false;
  },

  // render review video by id
  reviewVideo: function(review) {
    if (review.vids) {
      return `<iframe src="https://player.vimeo.com/video/${review.vids}?title=0&amp;app_id=122963" width="135" height="240" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" title=""></iframe>`;
    }
    return "";
  }
});

// change the defer-x-data to x-data on widget and initialise
let alpineReviews = document.getElementById('alpineReviews');
if (alpineReviews) {
  // Stop Alpine from detecting changes to the DOM while we set the x-data attributes.
  // Note:
  // Not strictly necessary, but for some reason Alpine doesn't automatically detect
  // these attribute changes and I have to manually initialize the component. In case
  // this changes in the future and Alpine does detect these attribute changes, I want
  // to make sure Alpine definitely does not initialize the components automatically.
  Alpine.mutateDom(() => {
    alpineReviews.setAttribute('x-data', alpineReviews.getAttribute('defer-x-data'));
  })
  // Initialize the component manually
  Alpine.initTree(alpineReviews);
}
